// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3VROF","gfeWrapper":"CalendarEvent_gfeWrapper__1sDg7"};